module.exports = __webpack_public_path__ + "media/images/posts/wedding_planning_tasks2-6dfe77edb577ded4890274089ba2624a.png";